import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ServiceSelectionProvider } from "@/components/ServiceSelectionProvider";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { AuthProvider } from "@/contexts/AuthContext";
import Index from "./pages/Index";
import Rejoindre from "./pages/Rejoindre";
import RejoindreComite from "./pages/RejoindreComite";
import Auth from "./pages/Auth";
import EmployeeHours from "./pages/EmployeeHours";
import AdminPayroll from "./pages/AdminPayroll";
import AdminUserManagement from "./pages/AdminUserManagement";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <AuthProvider>
        <LanguageProvider>
          <ServiceSelectionProvider>
            <Toaster />
            <Sonner />
            <BrowserRouter>
              <Routes>
              <Route path="/" element={<Index />} />
                <Route path="/rejoindre" element={<Rejoindre />} />
                <Route path="/rejoindre-comite" element={<RejoindreComite />} />
                <Route path="/auth" element={<Auth />} />
                <Route path="/hours" element={<EmployeeHours />} />
                <Route path="/admin" element={<AdminPayroll />} />
                <Route path="/admin/users" element={<AdminUserManagement />} />
                <Route path="/themes" element={<Navigate to="/#services" replace />} />
                {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </BrowserRouter>
          </ServiceSelectionProvider>
        </LanguageProvider>
      </AuthProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
